import { useState, useEffect } from "react";
import { IEmpresas } from "../../interfaces/IEmpresas";
import { ICredito, IDebito } from "../../interfaces/IRelatorio";

function RelatorioEstorno({ empresa, dataInicial, dataFinal }: { empresa: IEmpresas | undefined, dataInicial: Date | undefined, dataFinal: Date | undefined }) {

    const [carregado, setCarregado] = useState<boolean>(false);
    const [creditos, setCreditos] = useState<ICredito>();
    const [debitos, setDebitos] = useState<IDebito>();

    useEffect(() => {
        if (!carregado) {
            setCarregado(true);
        }
    }, [carregado]);


    return <>
        { 
            dataInicial && dataFinal ?
                carregado ? 
                    <>
                        <table className="table mt-10">
                            <thead>
                                <tr>
                                <th scope="col">Conta</th>
                                <th scope="col">Descrição</th>
                                <th scope="col">Valor</th>
                                <th scope="col">Tipo</th>
                                </tr>
                            </thead>
                        </table>
                    </>
                : <p className="mt-5">Carregando...</p>
            : <h2 className="mt-5">Preencha o campo Período e clique em buscar para carregar os dados</h2>
        }
    </>
};

export default RelatorioEstorno;